module.exports = __webpack_public_path__ + "img/processo de isolamento 3.56e5c3ef.webp";